import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  displayName: "elements__Wrapper",
  componentId: "sc-1jcppjh-0"
})(["margin-left:", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}"], function (_ref) {
  var dimensions = _ref.theme.dimensions;
  return dimensions.small;
});